import React from 'react';
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  EditButton,
  Responsive,
  SimpleList,
  Show,
  SimpleShowLayout,
  ReferenceInput,
  SelectInput,
  ReferenceField
} from "react-admin";

export const PesadoresFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" alwaysOn autoFocus />
      <TextInput label="Usuario o dni" source="searchdni" autoFocus />
      <ReferenceInput reference="predios" source="predio">
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
    </Filter>
  )
}

const PesadorNameEdit = ({ record }) => {
  return (
    <Responsive
      small={<span>Editar Pesador</span>}
      medium={
        <span>Editar Pesador: {record ? `"${record.nombre}"` : ""}</span>
      }
    />
  );
};

const PesadorNameShow = ({ record }) => {
  return <span>Mostrando: {record ? `"${record.nombre}"` : ""}</span>;
};

export const PesadorShow = props => (
  <Show title={<PesadorNameShow />} {...props}>
    <SimpleShowLayout>
      <TextField label="Nombre y Apellido" source="nombre" />
      <TextField label="Usuario o dni" source="dni" />
    </SimpleShowLayout>
  </Show>
);

export const PesadorEdit = props => (
  <Edit title={<PesadorNameEdit />} {...props}>
    <SimpleForm>
      <TextInput label="Nombre y Apellido" source="nombre" />
      <TextInput label="Usuario o dni" source="dni" />
      <ReferenceInput reference="predios" source="predio">
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <TextInput label="Contraseña" source="validacion" type="password" />
    </SimpleForm>
  </Edit>
);

export const PesadorCreate = props => (
  <Create {...props} title="Registrar Pesador">
    <SimpleForm redirect="/pesadores">
      <TextInput label="Nombre y Apellido" source="nombre" />
      <TextInput label="Usuario o dni" source="dni" />
      <ReferenceInput reference="predios" source="predio">
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
      <TextInput label="Contraseña" type="password" source="validacion" />
    </SimpleForm>
  </Create>
);

export const EditablePesadorList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<PesadoresFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record =>
            record.nombre.replace(/\b\w/g, l => l.toUpperCase())
          }
          tertiaryText={record => "Usuario/dni: " + record.dni}
        />
      }
      medium={
        <Datagrid>
          <TextField style={{ textTransform: "capitalize" }} source="nombre" />
          <TextField source="dni" label="Usuario/dni"/>
          <ReferenceField label="Predio" reference="predios" source="predio">
            <TextField  source="nombre" />
          </ReferenceField>
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

export const PesadorList = props => (
  <List
    {...props}
    bulkActions={false}
    filters={<PesadoresFilter />}
    sort={{ field: "nombre", order: "ASC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.nombre}
          tertiaryText={record => "Usuario/dni: " + record.dni}
          linkType="show"
        />
      }
      medium={
        <Datagrid>
          <TextField source="nombre" />
          <TextField source="dni" label="Usuario/dni" />
        </Datagrid>
      }
    />
  </List>
);



// WEBPACK FOOTER //
// ./src/services/pesadores.js